var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFunctionalUpskilling = function SvgFunctionalUpskilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#functional-upskilling_svg__a)",
    fillRule: "evenodd",
    d: "m40 6.867-5.708-1.153L33.142 0l-5.803 5.714c-7.971-4.52-18.053-2.449-23.6 4.85-5.547 7.3-4.853 17.58 1.625 24.066S22.11 41.81 29.4 36.257c7.29-5.554 9.36-15.648 4.844-23.628zm-12.433-.162h.133l.095-.2 4.757-4.762.95 4.762 4.757.952-4.756 4.762-.447.296.057.095-.438.428-4.756-.952-.951-4.762zm-4.61 31.722A17.39 17.39 0 0 0 35.72 21.639a17.4 17.4 0 0 0-2.15-8.315l-.59.59-5.212-1.037-9.218 9.228h-.39l-.267-.266v-.372l.143-.152 9.094-9.105-1.037-5.22.59-.59A17.355 17.355 0 0 0 5.851 9.582a17.41 17.41 0 0 0-2.438 20.956 17.36 17.36 0 0 0 19.544 7.889",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#functional-upskilling_svg__b)",
    d: "M38.543 7.39 34.19 5.81l-1.578-4.398-5.902 5.932 1.023 5.117 5.053.815z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#functional-upskilling_svg__c)",
    fillRule: "evenodd",
    d: "M6.91 25.587A11.98 11.98 0 0 0 18.067 33v-.083A11.97 11.97 0 0 0 28 27.554a12.02 12.02 0 0 0 1.077-11.252l-.092-.194-.35-.111-.553.268.166.387a11.09 11.09 0 0 1-3.116 12.84 11.04 11.04 0 0 1-13.173.714 11.09 11.09 0 0 1-4.482-12.428 11.06 11.06 0 0 1 10.589-7.883c1.482.012 2.946.326 4.303.924l.184.073.35-.147.139-.351-.148-.342-.157-.064a11.96 11.96 0 0 0-13.16 2.458A12.015 12.015 0 0 0 6.91 25.587m10.806-9.876h.194l.184-.259v-.397l-.304-.212h-.147a6.21 6.21 0 0 0-5.81 6.33 6.207 6.207 0 0 0 6.07 6.08 6.206 6.206 0 0 0 6.32-5.82v-.193l-.259-.286h-.617v.387a5.3 5.3 0 0 1-5.397 4.973 5.303 5.303 0 0 1-5.189-5.19 5.304 5.304 0 0 1 4.955-5.413",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#functional-upskilling_svg__d)",
    d: "m28.928 16.125-.351-.11-.554.267.166.387a11.076 11.076 0 1 1-5.889-5.88l.185.075.35-.148.14-.35-.12-.342-.158-.065a12 12 0 1 0 6.35 6.36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#functional-upskilling_svg__e)",
    d: "M17.771 15h-.143A6.006 6.006 0 1 0 24 21.372v-.188l-.25-.276h-.598v.375a5.131 5.131 0 1 1-5.452-5.444h.187l.24-.277v-.383z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__a",
    x1: 0,
    x2: 40,
    y1: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__b",
    x1: 26.711,
    x2: 38.575,
    y1: 13.276,
    y2: 1.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__c",
    x1: 6,
    x2: 30,
    y1: 33,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__d",
    x1: 6,
    x2: 30,
    y1: 33,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__e",
    x1: 12,
    x2: 24,
    y1: 27,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })))));
};
export { SvgFunctionalUpskilling as ReactComponent };
export default __webpack_public_path__ + "fonts/functional-upskilling-de6d204479fd76fc1f23056ef840cdbe.svg";